import EventEmitter from 'events';

const EventEmitterData = new EventEmitter()
export default EventEmitterData;
